export function supalog(...props: any[]) {
  if (localStorage.getItem("supabanner-logging") !== "enabled") return;
  console.log(...props);
}
